import { styled } from "goober";
import { useScrollRestoration } from "../lib/urls";

const Container = styled("div")`
  height: 100%;
  overflow: auto;
  overscroll-behavior: none;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export function MainScrollContainer({ children, style }: Props) {
  const scrollRef = useScrollRestoration();

  return (
    <Container ref={scrollRef} style={style}>
      {children}
    </Container>
  );
}
